<template>
  <narrow-container>
    <full-view-spinner :show="deactivateInProgress" />
    <h1 class="headline-small">
      {{ $i18n.t('AUTO_TOPUP.DEACTIVATE.CONFIRM.HEADER') }}
    </h1>
    <p>
      {{ $i18n.t('AUTO_TOPUP.DEACTIVATE.CONFIRM.INFO') }}
    </p>
    <submit-button
      id="deactivateAtuConfirmSubmitButton"
      :label="this.$i18n.t('COMMON.BACK')"
      :on-click="back"
      :spacing="false"
    />
    <br>
    <a
      id="deactivateAutoTopupConfirm"
      class="button button--black button--big"
      @click.prevent="deactivateAutoTopup"
    >
      {{ $i18n.t('AUTO_TOPUP.DEACTIVATE.BUTTON_LABEL') }}
    </a>
  </narrow-container>
</template>

<script>

  const RESP_CODE_NOT_ALLOWED = 2;

  export default {
    name: "DeactivateAutoTopupConfirm",
    components: {},
    props: {},
    data: function() {
      return {
        deactivateInProgress: false
      }
    },
    methods: {
      deactivateAutoTopup: function() {
        if(this.deactivateInProgress) {
          return;
        }

        this.deactivateInProgress = true;
        this.$http.delete("api/user/dreitvkarte/autoTopup", null)
          .then(
            () => {
              this.$store.commit("autotopup/removeAutoTopupStatus");
              this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'AutoTopup deactivate',label: 'Success', value: 0, noninteraction: false });
              this.$router.push({name: 'atuDeactivated'});
            }
          ).catch(
          callData => {
            this.processErrorResponse(callData);
          }
        ).finally(
          () => {
            this.deactivateInProgress = false;
          }
        )
      },
      processErrorResponse: function(callData) {
        if(callData.response.data && callData.response.data.responseCode == RESP_CODE_NOT_ALLOWED) {
          this.$store.commit("setErrorMessage", this.$i18n.t('AUTO_TOPUP.DEACTIVATE.ERROR.NOT_ALLOWED'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'AutoTopup deactivate',label: 'Error - not allowed', value: 0, noninteraction: false });
          this.$store.commit("autotopup/removeAutoTopupStatus");
          this.$router.push({name: 'topUp'});
        } else {
          this.$store.commit("setErrorMessage", this.$i18n.t('COMMON.ERROR_MESSAGES.TECHNICAL_ISSUE'));
          this.$gtm.trackEvent({ category: 'Drei TV Streamingkarte',action: 'AutoTopup deactivate',label: 'Error - technical issue', value: 0, noninteraction: false });
        }
      },
      back: function() {
        this.$router.push({name: 'topUp'});
      },
    }
  }
</script>

<style scoped>

</style>
